import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Subject } from "rxjs";

import {
	ManifestType,
	DownloadKind,
	Manifest,
	CombinedManifest
} from "./download/models";

@Injectable()
export class DownloadService {
	private statusCode = new Subject<number>();
	public statusCodeDone$ = this.statusCode.asObservable();

	constructor(private http: HttpClient) { }

	public async getManifest(downloadType: ManifestType) {
		// grab the manifest data
		const combinedManifest = await this.http
			.get<CombinedManifest>(`https://d.cloud.impulse.com/safeconnect/manifest.json`)
			.toPromise();

		// filter down just just the list of results we care about for this kind of download page
		const results: Manifest[] = [];
		switch (downloadType) {
			case ManifestType.STANDARD:
				results.push(combinedManifest[DownloadKind.OVA_LATEST]);
				results.push(combinedManifest[DownloadKind.HYPER_V_LATEST_SMALL]);
				break;
			case ManifestType.SMALL:
				results.push(combinedManifest[DownloadKind.OVA_LATEST_SMALL]);
				results.push(combinedManifest[DownloadKind.HYPER_V_LATEST_SMALL]);
				break;
			case ManifestType.TACACS:
				results.push(combinedManifest[DownloadKind.TACACS]);
				break;
			default:
				throw new Error(`unrecognized download type: ${downloadType}`);
		}

		// error checking, if any of those are missing remove them from the output
		return results.filter((manifest) => {
			return !!manifest;
		});
	}

	public download(manifest: Manifest) {
		try {
			window.open(manifest.url, "downloadFrame");
			this.statusCode.next(200);
		} catch (e) {
			// TODO error handling
		}
	}
}
